<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/safety/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>富地滋的品質</h1>
        </div>
      </header>
      <HeaderNav activeLink="safety" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              建構確實的品質保證體制， 讓每一個人感到安全及安心。
            </h2>
            <div class="row justify-content-center mb-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/safety/safty_kanri.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
            <h2 class="section-title">FORDAYS歧阜工場</h2>
            <p class="mb-0">
              為了守護FORDAYS製品的「安全及安心」，2017年FORDAYS設立了歧阜工場。
              <br />
              在岐阜工場內，我們使用在地豐富自然環境中所產生的水來製作標準飲用水。並以此飲用水作為原料，經過活性碳、去離子及精密過濾的處理，製作出符合醫療用精製水標準的水加以利用。
              <br />
              所有各種原物料都會經過嚴格的檢查才能帶進工場內。而為了避免外部的異物混入，製造設備皆設置在無塵室內。作業員都必須穿著無塵衣且須通過空氣浴塵室才能進到生產區域內。
            </p>
            <div class="row justify-content-center my-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/safety/factory01.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
            <div class="row justify-content-center mt-3">
              <div class="col-md-12">
                <p>
                  經過原料秤重、調和、過濾、殺菌、容器填充、倒瓶殺菌、冷卻、去除水分、目視檢查、標籤黏貼、包裝及最後嚴密的品質檢查後才算是完成的製品。歧阜工場導入了各種最新型的設備，並在調和工程之後全部採用自動化作業。
                </p>
              </div>
              <div class="col-md-6 mt-5">
                <img
                  src="@/assets/public/images/safety/factory02.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">品質管理中心</h2>
            <p>
              FORDAYS為了守護製品的「安全及安心」，2009年於靜岡縣的伊豆高原設立了「FORDAYS品質管理中心」。品質管理中心以核酸飲品為首，將全國各地的工場所製造的產品取樣(包含食品與保養品)，依照生產批號進行保存，並透過出貨前的驗收及通過時效測試確認產品在品質保證期間內的安定性等來確保製品的品質，建構讓顧客都能感到安心的品質保證體制。
              <br />
              為了建構品質保證體制，不單單只是進行製品的品質管理，更是從原料的品質確認到工場的製造品質、物流階段的品質，然後一直到顧客們使用完製品後整體一連串的品質保證體制。
            </p>
            <div class="row justify-content-center">
              <div class="col-md-6 my-5">
                <img
                  src="@/assets/public/images/safety/photo_safety02.jpg"
                  class="w-100"
                  alt
                />
              </div>
              <div class="col-md-12 mt-3">
                <p>
                  工場監督檢查也是其中之一。品質管理中心的人員會前往製造工場進行生產線的監督檢查，並在之後和工場的生產&amp;品質管理負責人討論如何能夠更加提升品質。
                  藉由經驗的累積，建構更堅固的品質保證體制。
                </p>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-6 my-5">
                <img
                  src="@/assets/public/images/safety/photo_safety03.jpg"
                  class="w-100"
                  alt
                />
              </div>
              <div class="col-md-12 mt-3">
                <p>
                  另外，還舉辦了萃取鮭魚精巢DNA的體驗及製作護手霜的活動，進而從中更能了解FORDAYS製品的先進性與安全性。
                  <br />
                  透過這樣的學習參觀會，讓大家都能確實了解製品，我們也會持續努力讓FORDAYS的製品深受大家喜愛且更加安心。因此品質管理中心可說是連結大家與FORDAYS之間信賴的設施。
                </p>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">核酸的故事</h2>
            <p>
              以鮭魚精巢萃取的核酸研究歷史悠久，最遠可追溯到1871年(明治4年)。而在約80年前，華生(James
              Watson)與克里克(Francis
              Crick)兩位發現了DNA的雙重螺旋構造。而後透過許多著名的研究者和技術開發者的努力，進而將從鮭魚精巢取得的核物質進行分離，並取名為「Nucleic
              acid」(核酸)，一直發展至今日的模樣。
            </p>
            <p>
              日本核酸研究的領頭者為東京帝大(現東京大學)理學部。師事左右田徳郎教授的東京帝大
              安藤銳郎教授是世界上第一位將關於魚精蛋白(與DNA結合在一起的蛋白質)的化學構造成功解析的人(昭和36年)，並將之使用於生物學及藥劑．食用上。而同樣師事左右田徳郎教授的東京帝大
              江上不二夫教授是從事核酸和酵素相關的研究，江上教授發現的核糖核酸酶T1，讓Holly等人研究的轉移RNA的一級構造解析有所進展。因此在昭和43年，Holly等人得到了諾貝爾獎的肯定。在昭和28年，江上教授、安藤教授共同出版了日本最初的核酸相關研究書籍「核酸及核蛋白
              ―理化化學・生物學・醫學―」，書中內容主要是提及關於核酸・核蛋白的萃取・精製法、核酸和核蛋白的物理性質、酵素處理法、核酸和核蛋白的醫學及生物學的觀點見解等。由此可見源遠流長的核酸研究歷史能發展至今，是由許多研究者的努力而促成的。
            </p>
            <p>
              因此以培養至今的核酸及核蛋白的物理性質、機能性、萃取技術為基礎，從那時開始就有提取核酸原料來加工的製造場所，經過半世紀以上到了今日，也是全力投入醫療用・食品用的核酸原料製造，並持續著毫無偏差、高度技術的原料製造。甚至在製造責任者中，有一位長達50年以上每天都持續接觸著精巢的專業人士表示「只要看到精巢，鼻水就會條件反射地流出來」「只要看一眼精巢，就能知道原料的採收量(核酸含有量)」。而當被詢問到：「從精巢萃取的核酸原料的含有成分，有沒有出現偏差過？」。他斬釘截鐵地回答：「看到精巢後我們也會隨之調整，所以從來沒有出現偏差值過。」
            </p>
            <p>
              敝公司身為核酸營養的先驅企業，我們以核酸研究的發展與普及為己任而努力至今。我們不僅僅和昭和大學、東京大學及其他研究機關共同合作，同時也開設了許多捐贈講座，並和生命科學研究所共同進行基礎研究知識的探討。然而，研究進行中，若不明白核酸原料的製造方法、不能理解分析結果、偶爾出現「偏差值」的話，都會成為大瓶頸而妨礙研究的進行。因此核酸原料是如何製造的，帶有怎麼樣的物理性質和機能性，這些情報的獲得是研究可以持續進行的重要因素。另外，為了不斷提供給各位值得信賴的核酸產品，我們非常重視原料的均一性・安定性。所以我們從未發生無論如何都沒辦法改善的問題，甚至負責人親自出馬還沒辦法解決的狀況。
            </p>
            <p>
              我們不斷地絞盡腦汁、思考著該如何「持續提供值得各位信賴、擁有科學依據、確實感受且安心‧安全的產品」；又該如何「持續製造改良進化且更優質的產品」。
            </p>
            <p>
              我們以核酸營養的先驅企業為己任，在每天的研究過程中，遇到各式各樣的事情，也遇到了許多研究者‧開發者‧技術者們。
            </p>
            <p>
              而以宇住博士為領導的團隊，會持續將我們研究至今的成果發揚光大。為了從核酸營養的先驅企業，進化成「核酸的先鋒者」，我們決定要從事核酸的原料開發。這是繼成立自己的核酸飲品生產工場後，對產品應有的另一種責任。
            </p>
            <p>
              1871年揭開了以鮭魚精巢萃取的核酸研究歷史序幕，透過多位的研究者‧開發者‧技術者‧製造者的熱忱而創造出現在的核酸原料。我們與長久從事核酸研究的專業人士合作，並從中汲取他們的經驗及知識，以最先進的研究為基礎，今後仍不斷地開發更好的核酸原料。而這是為了開創一個永續且未來充滿無限發展可能性的開發環境，並且賦予肩負未來的年輕研究員擁有繼往開來的環境，奠定「100年後的富地滋」的基石。
            </p>
            <p>
              2017年我們設立的富地滋自家工場，其中生產現場「可視化」，是我們富地滋「邁向未來的一步」。並且對於講究的每個原料，也正朝著「可視化」的方向推動發展中。
            </p>
            <p>
              富地滋公司一直以來以追求真正有價值、優質的東西，努力研究並開發為目標，因此我們有信心提供給各位最好的！
            </p>
          </div>
        </section>
        <!-- m-sec -->
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
export default {
  name: "SafetyScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>